import { useEffect, useState } from 'react';
import { InputText, IconTrash } from '@ui/src';
import { EntityAddressesFormValues } from '../../hoc/types';
import { AddressEntityTypes } from './types';

import cn from './blacklist.module.css';

const AddressEntity = ({
  address,
  setAddresses,
  addresses,
  length,
  id,
}: AddressEntityTypes) => {
  const [values, setValues] = useState<EntityAddressesFormValues>();

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const nextValues = { ...values };

    if (e.target.name === `addressTypeDesc-${id}`) {
      nextValues.addressTypeDesc = e.target.value;
    } else if (e.target.name === `address1-${id}`) {
      nextValues.address1 = e.target.value;
    } else if (e.target.name === `address2-${id}`) {
      nextValues.address2 = e.target.value;
    } else if (e.target.name === `city-${id}`) {
      nextValues.city = e.target.value;
    } else if (e.target.name === `postalCode-${id}`) {
      nextValues.postalCode = e.target.value;
    } else if (e.target.name === `country-${id}`) {
      nextValues.country = e.target.value;
    } else if (e.target.name === `isoStandard-${id}`) {
      nextValues.isoStandard = e.target.value;
    }

    setValues(nextValues as EntityAddressesFormValues);

    if (addresses) {
      const nextAddresses = addresses?.map((item) => {
        let result = { ...item };

        if (result.id === address?.id) {
          result = nextValues as EntityAddressesFormValues;
        }

        return result;
      });

      setAddresses(nextAddresses);
    }
  };

  useEffect(() => {
    if (address) {
      setValues(address);
    }
  }, [address]);

  return (
    <div className={cn.entityWrapper}>
      <div className={cn.entityValue} style={{ width: `${100 / length}%` }}>
        <InputText
          name={`addressTypeDesc-${id}`}
          value={values?.addressTypeDesc}
          placeholder="Enter type"
          onChange={onChange}
          className={cn.borderless}
        />
      </div>
      <div className={cn.entityValue} style={{ width: `${100 / length}%` }}>
        <InputText
          name={`address1-${id}`}
          value={values?.address1}
          placeholder="Enter address"
          onChange={onChange}
          className={cn.borderless}
        />
      </div>
      <div className={cn.entityValue} style={{ width: `${100 / length}%` }}>
        <InputText
          name={`address2-${id}`}
          value={values?.address2}
          placeholder="Enter address"
          onChange={onChange}
          className={cn.borderless}
        />
      </div>
      <div className={cn.entityValue} style={{ width: `${100 / length}%` }}>
        <InputText
          name={`city-${id}`}
          value={values?.city}
          placeholder="Enter city"
          onChange={onChange}
          className={cn.borderless}
        />
      </div>
      <div className={cn.entityValue} style={{ width: `${100 / length}%` }}>
        <InputText
          name={`country-${id}`}
          value={values?.country}
          placeholder="Enter country"
          onChange={onChange}
          className={cn.borderless}
        />
      </div>
      <div className={cn.entityValue} style={{ width: `${100 / length}%` }}>
        <InputText
          name={`postalCode-${id}`}
          value={values?.postalCode}
          placeholder="Enter Postal Code"
          onChange={onChange}
          className={cn.borderless}
        />
      </div>
      <div
        className={`${cn.entityValue} ${cn.flex}`}
        style={{ width: `${100 / length}%` }}
      >
        <InputText
          name={`isoStandard-${id}`}
          value={values?.isoStandard}
          placeholder="Enter ISO"
          onChange={onChange}
          labelClassName={cn.withMargin}
          className={cn.borderless}
        />
        <button
          type="button"
          className={cn.deleteEntityButton}
          onClick={() => {
            setAddresses(
              addresses?.filter(
                (item) => item.id !== id,
              ) as EntityAddressesFormValues[],
            );
          }}
        >
          <IconTrash />
        </button>
      </div>
    </div>
  );
};

export default AddressEntity;
